import { alpha } from '@material-ui/core/styles/colorManipulator';
import { palette } from '../../settings/themes/colors';

const styles = theme => ({
  root: {
    width: '100%',
    background: 'white',
    border: 'none',
    boxShadow: `inset 0 -7px 0 0 ${theme.palette.primary.light}`
  },
  tooltip: {
    backgroundColor: 'rgb(97,97,97)'
  },
  newFeature: {
    '& .MuiChip-label': {
      padding: 0,
      fontSize: 10,
      color: `${palette.white} !important`
    },
    height: 'fit-content',
    padding: '0px 4px',
    marginLeft: 2,
    backgroundColor: palette.captuDataYellow
  },
  menu: {
    '&__toolbar': {
      minHeight: 55
    },
    '&__tooltip': {
      color: theme.palette.secondary.main
    },

    '&__logo': {
      '&--client': {
        maxHeight: 38,
        marginRight: 32
      },
      '&--cap': {
        maxHeight: 55
      }
    },

    '&__menu': {
      alignSelf: 'flex-end',
      marginLeft: 'auto',
      marginBottom: 3,

      '&__item': {
        position: 'relative',
        marginBottom: 4,
        padding: '10px 24px',
        fontSize: 12,
        borderRadius: 0,
        height: 54,
        '&:hover': {
          boxShadow: `0 7px 0 0 ${theme.palette.secondary.main}`
        }
      },
      '&__action': {
        marginBottom: 4,
        padding: '10px 24px',
        fontSize: 12,
        borderRadius: 0,
        height: 54,
        boxShadow: `0 7px 0 0 ${theme.palette.primary.main}`,
        display: 'flex',
        color: theme.palette.primary.main,
        '& .MuiSvgIcon-root': {
          color: theme.palette.primary.main
        },
        '& .MuiInputLabel-root': {
          fontSize: 12,
          fontWeight: 500,
          color: theme.palette.primary.main,
          display: 'flex',
          alignItems: 'center',
          margin: 0,
          paddingRight: 5
        },
        '&_select': {
          border: 'none',
          '& .MuiSelect-select': {
            fontSize: 12,
            fontWeight: 500,
            color: theme.palette.primary.main,
            padding: 0,
            paddingRight: 24,
            '&:focus': {
              background: 'none'
            }
          }
        },
        '&:hover': {
          boxShadow: `0 7px 0 0 ${theme.palette.secondary.main}`
        }
      },
      '&__item_selected': {
        background: 'none',
        boxShadow: `0 7px 0 0 ${theme.palette.secondary.main}`
      }
    }
  },
  submenuBar: {
    width: '100%',
    background: palette.peakcock,
    boxShadow: 'none'
  },
  submenuToolbar: {
    minHeight: 48,
    display: 'flex',
    justifyContent: 'flex-end',
    padding: 0
  },
  submenuItem: {
    color: `${palette.white} !important`,
    borderRadius: 0,
    height: 48,
    padding: '10px 32px',
    fontSize: 14,
    fontWeight: 500,
    '&:hover': {
      background: palette.captudataBlue
    }
  },
  submenuItem_selected: {
    background: palette.cerulean,
    '&:hover': {
      background: palette.cerulean
    }
  },
  client_logo: {
    maxHeight: 38,
    marginRight: 32
  },
  cap_logo: {
    maxHeight: 55
  },
  grow: {
    flexGrow: 1
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20
  },
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block'
    }
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.white, 0.25)
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto'
    }
  },
  searchIcon: {
    width: theme.spacing(9),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  inputRoot: {
    color: 'inherit',
    width: '100%'
  },
  inputInput: {
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(10),
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: 200
    }
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex'
    }
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  }

  // root: {
  //   background: 'white',
  //   border: 'none',
  //   boxShadow: `inset 0 -7px 0 0 ${theme.palette.primary.light}`,

  //   '&__toolbar': {
  //     minHeight: 55
  //   },

  //   '&__logo': {
  //     '&--client': {
  //       maxHeight: 38,
  //       marginRight: 32
  //     },
  //     '&--cap': {
  //       maxHeight: 55
  //     }
  //   },

  //   '&__menu': {
  //     alignSelf: 'flex-end',
  //     marginLeft: 'auto',
  //     marginBottom: 3,

  //     '&__item': {
  //       marginBottom: 4,
  //       padding: '10px 24px',
  //       fontSize: 16,
  //       borderRadius: 0,

  //       '&:hover': {
  //         background: 'none',
  //         boxShadow: `0 7px 0 0 ${theme.palette.secondary.main}`
  //       }
  //     }
  //   }
  // }
});

export default styles;
